import { render, staticRenderFns } from "./PDAPage.vue?vue&type=template&id=cb96739c&scoped=true"
import script from "./PDAPage.vue?vue&type=script&lang=js"
export * from "./PDAPage.vue?vue&type=script&lang=js"
import style0 from "./PDAPage.vue?vue&type=style&index=0&id=cb96739c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb96739c",
  null
  
)

export default component.exports